export default "__VITE_ASSET__efa04157__"